// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__2Kyqv","lds-roller":"LoadingSpinner_lds-roller__mgwD8"};